// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Quicksand:wght@300;400;500;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
  font-family: "Quicksand", sans-serif;
}
body,
html {
  background-color: #0b0b22;
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
}
body {
  font-size: 12px;
  color: #424242;
}
.menu_mobile {
  background-color: #042c54;
  color: white !important;
  width: 100%;
  display: flex;
  font-weight: 600;
  font-size: 20px;
  padding: 10px;
  justify-content: space-between;
}
.nav_mobile {
  background-color: #042c54;
  width: 100%;
  display: flex;
  font-weight: 600;
  font-size: 14px;
  text-transform: uppercase;
}
.nav_list_mobile {
  width: 60%;
  padding: 0;
  margin: 0;
  text-align: left;
}
.nav_items_mobile {
  box-sizing: border-box;
  display: inline-block;
  text-align: right;
  line-height: 24px;
  text-transform: uppercase;
  color: white !important;
}
.icon_menu a {
  text-decoration: none;
  color: white !important;
  font-size: 22px;
  text-align: center;
}
.nav_mobile a {
  display: inline-block;
  color: white;
  padding: 1.3em;
  text-decoration: none;
}
.nav {
  background-color: #042c54;
  width: 100%;
  display: flex;
  font-weight: 600;
  font-size: 14px;
  text-transform: uppercase;
}
.nav_list {
  width: 80%;
  padding: 0;
  margin: 0;
  text-align: right;
}
.logo {
  width: 20%;
  padding: 0;
  margin: 0;
  text-align: left;
  box-sizing: border-box;
  display: inline-block;
  line-height: 24px;
}
.nav_items {
  box-sizing: border-box;
  display: inline-block;
  text-align: right;
  line-height: 24px;
  text-transform: uppercase;
}
.nav a {
  display: inline-block;
  padding: 1.3em;
  text-decoration: none;
  color: white !important;
}
.nav a:hover {
  text-decoration: none;
}
.hero {
  display: flex;
  align-items: center;
  min-height: 380px;
  width: 100%;
  text-align: center;
  background-position: center;
  background-color: Black !important;
}
.hero_inner {
  margin: 0 auto;
  max-width: 800px;
}
.hero_title {
  color: #fff;
  font-weight: 600;
  font-size: 36px;
  text-shadow: 1px 1px #141414;
}
.hero_sub_title {
  color: #fff;
  margin-top: 16px;
  font-size: 18px;
  font-weight: 600;
  text-shadow: 1px 1px #141414;
}
main {
  width: 100%;
  margin: 0 auto;
}
.content {
  padding: 32px;
}
.latest {
  width: 100%;
  margin-top: 30px;
  margin-bottom: 50px;
  text-align: center;
}
.latest h1 {
  font-weight: 700;
  font-size: 2rem;
  margin-bottom: 50px;
  color: white;
}
.list {
  margin: 32px auto auto;
  text-align: left;
  display: grid;
  grid-row-gap: 16px;
}
.list_item {
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
  background-color: rgba(255, 255, 255, 0.041);
  width: 100%;
  border-radius: 16px;
  overflow: hidden;
  position: relative;
}
.city {
  position: absolute;
  top: 8px;
  left: 16px;
  border-radius: 5px;
  background-color: #042c54;
  padding: 5px 10px 5px;
  color: white;
  font-weight: 500;
}
.list_item_content {
  padding: 16px;
}
.list_item_thumb {
  width: 100%;
  max-height: 200px;
}
.list_item_rating {
  font-size: 12px;
  text-transform: uppercase;
  color: #999;
  font-weight: 500;
}
.list_item_rating_value {
  padding: 1rem;
  color: red;
  text-decoration: none;
  display: inline-block;
  width: 44px;
  height: 44px;
}
.list_item_title {
  font-weight: 500;
  font-size: 16px;
  margin-top: 10px;
  transition: 0.3s opacity;
}
.list_item_title:hover {
  opacity: 0.5;
}
.list_item_title a {
  width: 44px;
  height: 44px;
  text-decoration: none;
  color: inherit;
  padding-top: 1rem;
}
.list_item_desc {
  margin-top: -30px;
  font-size: 12px;
  line-height: 1.5em;
  color: #ffffff8f;
}
footer {
  background-color: #042c54;
  color: white;
  font-size: 14px;
  padding: 2em;
  width: 100%;
  text-align: center;
}
.skip-link {
  position: absolute;
  top: -100px;
  left: 0;
  background-color: #bf1722;
  color: white;
  padding: 10px;
  font-size: 20px;
  z-index: 100;
  text-decoration: none;
}
.skip-link:focus {
  top: 100px;
}
`, "",{"version":3,"sources":["webpack://./src/styles/main.css"],"names":[],"mappings":"AACA;EACE,UAAU;EACV,SAAS;EACT,sBAAsB;EACtB,oCAAoC;AACtC;AACA;;EAEE,yBAAyB;EACzB,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;AACd;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,uBAAuB;EACvB,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,8BAA8B;AAChC;AACA;EACE,yBAAyB;EACzB,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;AACA;EACE,UAAU;EACV,UAAU;EACV,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,sBAAsB;EACtB,qBAAqB;EACrB,iBAAiB;EACjB,iBAAiB;EACjB,yBAAyB;EACzB,uBAAuB;AACzB;AACA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,YAAY;EACZ,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,yBAAyB;EACzB,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;AACA;EACE,UAAU;EACV,UAAU;EACV,SAAS;EACT,iBAAiB;AACnB;AACA;EACE,UAAU;EACV,UAAU;EACV,SAAS;EACT,gBAAgB;EAChB,sBAAsB;EACtB,qBAAqB;EACrB,iBAAiB;AACnB;AACA;EACE,sBAAsB;EACtB,qBAAqB;EACrB,iBAAiB;EACjB,iBAAiB;EACjB,yBAAyB;AAC3B;AACA;EACE,qBAAqB;EACrB,cAAc;EACd,qBAAqB;EACrB,uBAAuB;AACzB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,WAAW;EACX,kBAAkB;EAClB,2BAA2B;EAC3B,kCAAkC;AACpC;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,4BAA4B;AAC9B;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,4BAA4B;AAC9B;AACA;EACE,WAAW;EACX,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,0CAA0C;EAC1C,4CAA4C;EAC5C,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;EACrB,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;EACE,WAAW;EACX,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,UAAU;EACV,qBAAqB;EACrB,qBAAqB;EACrB,WAAW;EACX,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,wBAAwB;AAC1B;AACA;EACE,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,OAAO;EACP,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,eAAe;EACf,YAAY;EACZ,qBAAqB;AACvB;AACA;EACE,UAAU;AACZ","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Quicksand:wght@300;400;500;600;700&display=swap\");\n* {\n  padding: 0;\n  margin: 0;\n  box-sizing: border-box;\n  font-family: \"Quicksand\", sans-serif;\n}\nbody,\nhtml {\n  background-color: #0b0b22;\n  margin: 0;\n  padding: 0;\n  width: 100%;\n  height: 100%;\n}\nbody {\n  font-size: 12px;\n  color: #424242;\n}\n.menu_mobile {\n  background-color: #042c54;\n  color: white !important;\n  width: 100%;\n  display: flex;\n  font-weight: 600;\n  font-size: 20px;\n  padding: 10px;\n  justify-content: space-between;\n}\n.nav_mobile {\n  background-color: #042c54;\n  width: 100%;\n  display: flex;\n  font-weight: 600;\n  font-size: 14px;\n  text-transform: uppercase;\n}\n.nav_list_mobile {\n  width: 60%;\n  padding: 0;\n  margin: 0;\n  text-align: left;\n}\n.nav_items_mobile {\n  box-sizing: border-box;\n  display: inline-block;\n  text-align: right;\n  line-height: 24px;\n  text-transform: uppercase;\n  color: white !important;\n}\n.icon_menu a {\n  text-decoration: none;\n  color: white !important;\n  font-size: 22px;\n  text-align: center;\n}\n.nav_mobile a {\n  display: inline-block;\n  color: white;\n  padding: 1.3em;\n  text-decoration: none;\n}\n.nav {\n  background-color: #042c54;\n  width: 100%;\n  display: flex;\n  font-weight: 600;\n  font-size: 14px;\n  text-transform: uppercase;\n}\n.nav_list {\n  width: 80%;\n  padding: 0;\n  margin: 0;\n  text-align: right;\n}\n.logo {\n  width: 20%;\n  padding: 0;\n  margin: 0;\n  text-align: left;\n  box-sizing: border-box;\n  display: inline-block;\n  line-height: 24px;\n}\n.nav_items {\n  box-sizing: border-box;\n  display: inline-block;\n  text-align: right;\n  line-height: 24px;\n  text-transform: uppercase;\n}\n.nav a {\n  display: inline-block;\n  padding: 1.3em;\n  text-decoration: none;\n  color: white !important;\n}\n.nav a:hover {\n  text-decoration: none;\n}\n.hero {\n  display: flex;\n  align-items: center;\n  min-height: 380px;\n  width: 100%;\n  text-align: center;\n  background-position: center;\n  background-color: Black !important;\n}\n.hero_inner {\n  margin: 0 auto;\n  max-width: 800px;\n}\n.hero_title {\n  color: #fff;\n  font-weight: 600;\n  font-size: 36px;\n  text-shadow: 1px 1px #141414;\n}\n.hero_sub_title {\n  color: #fff;\n  margin-top: 16px;\n  font-size: 18px;\n  font-weight: 600;\n  text-shadow: 1px 1px #141414;\n}\nmain {\n  width: 100%;\n  margin: 0 auto;\n}\n.content {\n  padding: 32px;\n}\n.latest {\n  width: 100%;\n  margin-top: 30px;\n  margin-bottom: 50px;\n  text-align: center;\n}\n.latest h1 {\n  font-weight: 700;\n  font-size: 2rem;\n  margin-bottom: 50px;\n  color: white;\n}\n.list {\n  margin: 32px auto auto;\n  text-align: left;\n  display: grid;\n  grid-row-gap: 16px;\n}\n.list_item {\n  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);\n  background-color: rgba(255, 255, 255, 0.041);\n  width: 100%;\n  border-radius: 16px;\n  overflow: hidden;\n  position: relative;\n}\n.city {\n  position: absolute;\n  top: 8px;\n  left: 16px;\n  border-radius: 5px;\n  background-color: #042c54;\n  padding: 5px 10px 5px;\n  color: white;\n  font-weight: 500;\n}\n.list_item_content {\n  padding: 16px;\n}\n.list_item_thumb {\n  width: 100%;\n  max-height: 200px;\n}\n.list_item_rating {\n  font-size: 12px;\n  text-transform: uppercase;\n  color: #999;\n  font-weight: 500;\n}\n.list_item_rating_value {\n  padding: 1rem;\n  color: red;\n  text-decoration: none;\n  display: inline-block;\n  width: 44px;\n  height: 44px;\n}\n.list_item_title {\n  font-weight: 500;\n  font-size: 16px;\n  margin-top: 10px;\n  transition: 0.3s opacity;\n}\n.list_item_title:hover {\n  opacity: 0.5;\n}\n.list_item_title a {\n  width: 44px;\n  height: 44px;\n  text-decoration: none;\n  color: inherit;\n  padding-top: 1rem;\n}\n.list_item_desc {\n  margin-top: -30px;\n  font-size: 12px;\n  line-height: 1.5em;\n  color: #ffffff8f;\n}\nfooter {\n  background-color: #042c54;\n  color: white;\n  font-size: 14px;\n  padding: 2em;\n  width: 100%;\n  text-align: center;\n}\n.skip-link {\n  position: absolute;\n  top: -100px;\n  left: 0;\n  background-color: #bf1722;\n  color: white;\n  padding: 10px;\n  font-size: 20px;\n  z-index: 100;\n  text-decoration: none;\n}\n.skip-link:focus {\n  top: 100px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
